/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermsDto } from '../../models/terms-dto';

export interface TermsAdminControllerFindByIdV1$Params {
  id: string;
}

export function termsAdminControllerFindByIdV1(http: HttpClient, rootUrl: string, params: TermsAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
  const rb = new RequestBuilder(rootUrl, termsAdminControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TermsDto>;
    })
  );
}

termsAdminControllerFindByIdV1.PATH = '/api/v1/terms/admin/{id}';
